
  /**
   * url参数解密
   * 传入加密的json串
   * @param {*string} val
   */
  const DecryptUrl = val => {
    if (!utils.isString(val)) {
      return false;
    }
    try {
      let decryStr = window.atob(val); // 解码
      return window.decodeURIComponent(decryStr);
    } catch (err) {
      console.log('%c url-decry-error：' + JSON.stringify(err.stack), 'color:red;');
    }
    return false;
  }

  /**
 * 从地址栏获取指定参数值
 * @param {*string} param
 */
const GetQueryParam = (param) => {
    let h = window.location.href;
    let reg = new RegExp("[\?\&]?" + param + "=([,-\w]+)[\&]?", "i");
    if (reg.test(h)) {
      let v = reg.exec(h)[1];
      return v;
    }
    return "";
  };
  
  /**
   * 返回 地址栏 加密 Object
   * @param {*string} param
   */
function GetQueryParamOfObjEntry(key){
    let keyStr = GetQueryParam(key);
    if (!keyStr) {
      return "";
    }
    try {
      let objStr = DecryptUrl(keyStr);
      let obj = JSON.parse(objStr);
      return obj;
    } catch (err) {
      console.log('%c url-json-parse-error：' + JSON.stringify(err.stack), 'color:red;');
    }
    return "";
  }

  
export default {
    GetQueryParamOfObjEntry
  }